import { daDK } from '@mui/x-data-grid/locales';
import * as React from 'react';

import { Chip } from '@mui/material';
import { DataGridPremium } from '@mui/x-data-grid-premium';
import ServiceManagementDatagridToolbar from './ServiceManagementDatagridToolbar';

export default function ServiceManagementDatagrid(props) {
  const {
    initialRows = [],
    isLoading = true,
    setSelectedRow = () => {},
    account,
  } = props;

  const [list, setList] = React.useState([]);

  const rows = React.useMemo(() => {
    if (list.length === 0) return initialRows;
    return [
      ...initialRows.filter((o) =>
        o.Services.some((s) => list.includes(s.Name)),
      ),
    ];
  }, [initialRows, list]);

  const initialState = {
    sorting: {
      sortModel: [
        {
          field: 'Name',
          sort: 'desc',
        },
      ],
    },
  };

  const columns = [
    {
      field: 'AccountId',
    },
    {
      field: 'Name',
    },
    {
      field: 'Address',
    },
    {
      field: 'Services',
      renderCell: (params) => {
        return (
          <>
            {params.value.map((service) => (
              <Chip key={service.Id} label={service.Name} />
            ))}
          </>
        );
      },
    },
  ].map((column) => {
    return { ...column, flex: 1 };
  });

  return (
    <DataGridPremium
      localeText={daDK.components.MuiDataGrid.defaultProps.localeText}
      rows={rows}
      columns={columns}
      initialState={initialState}
      loading={isLoading}
      pinnedRows={{
        top:
          initialRows.length > 0 && account.AccountId
            ? [initialRows.find((o) => o.id === account.AccountId)]
            : [],
      }}
      slots={{
        toolbar: ServiceManagementDatagridToolbar,
      }}
      slotProps={{
        loadingOverlay: {
          variant: 'linear-progress',
          noRowsVariant: 'skeleton',
        },
        toolbar: {
          list: list,
          setList: setList,
        },
      }}
      onRowClick={(params) => {
        setSelectedRow(params.row);
      }}
      sx={{
        '.MuiDataGrid-aggregationColumnHeaderLabel': {
          display: 'none',
        },
        '& .cell-left-border': {
          borderLeft: (theme) => `1px solid ${theme.palette.divider}`,
        },
        '& .left-margin-cell': {
          paddingLeft: 7,
        },
        '& .autogenerated': {
          fontWeight: 'bold',
        },
        '& .MuiDataGrid-columnHeaderTitle': {
          whiteSpace: 'break-spaces',
          lineHeight: 1.5,
          fontWeight: 'bold',
        },
        '& .MuiDataGrid-columnHeaderTitleContainerContent': {
          height: '100%',
        },
        '& .MuiDataGrid-aggregationColumnHeader': {
          height: '100%',
        },
        '&.MuiDataGrid-root .MuiDataGrid-columnHeader--alignRight .MuiDataGrid-columnHeaderTitleContainer':
          {
            pl: 1,
          },
        border: 'none',
        '& .MuiDataGrid-cell:focus, & .MuiDataGrid-cell:focus-within, & .MuiDataGrid-columnHeader:focus, & .MuiDataGrid-columnHeader:focus-within':
          {
            outline: 'none',
          },
        '& .MuiDatagrid-root': {
          border: 0,
        },
        '.MuiDataGrid-withBorderColor': {
          border: 'none !important',
        },
        '& .MuiDatagrid-footerContainer': {
          border: 0,
        },
        '& .MuiDatagrid-bottomContainer': {
          border: 0,
        },
        '& .MuiDataGrid-main': {
          backgroundColor: (theme) =>
            theme.palette.mode === 'light' ? '#fff' : '#121212',
          borderRadius: 2,
          border: (theme) => `1px solid ${theme.palette.divider}`,
        },
        '& .MuiDataGrid-columnHeaders': {
          borderBottom: '1px solid',
          borderColor: 'divider',
        },
        '& .MuiDataGrid-columnsContainer': {
          backgroundColor: 'blue',
        },
        '& .selected-row': {
          backgroundColor: (theme) => theme.palette.action.selected,
          '&:hover': {
            backgroundColor: (theme) => theme.palette.action.selected,
          },
        },
      }}
    />
  );
}
